/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ArrowDownIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "arrow-down", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M12.5 18.5V6", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M18 13L12.5 18.5L7 13", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ArrowDownIcon);
export default ForwardRef;
//# sourceMappingURL=arrowDownIcon.js.map